import { createAsyncThunk } from '@reduxjs/toolkit'

import { RootState } from '../../app/store'
import { postData } from '../../shared/api/api'
import { PostPuzzleGuessRequest, PostPuzzleGuessResponse } from './types'
import {
  setDossierDiscoveredIds,
  setDossierProgress,
} from '../dossier/dossierSlice'

export const postPuzzleGuess = createAsyncThunk<
  PostPuzzleGuessResponse,
  PostPuzzleGuessRequest,
  { state: RootState }
>('puzzle/postPuzzleGuess', async (request, thunkAPI) => {
  const { sceneId, puzzleId, guess } = request
  const state = thunkAPI.getState()
  const { zone, user } = state
  const zoneId = zone?.data?.id

  if (!zoneId) {
    return thunkAPI.rejectWithValue(
      'Unable to fetch SceneById. Missing zoneId from state.'
    )
  }

  const body = {
    userId: user?.profile?.uid,
    guess,
  }

  try {
    const response = await postData<PostPuzzleGuessResponse>(
      `/zones/${zoneId}/scene/${sceneId}/puzzle/${puzzleId}`,
      body
    )
    // Check for dossierProgression in response
    if (response?.dossierProgression)
      thunkAPI.dispatch(setDossierProgress({ ...response.dossierProgression }))
    // Update discoveredIds
    if (response?.discoveredIds)
      thunkAPI.dispatch(setDossierDiscoveredIds(response.discoveredIds))
    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error || error.message || 'Unknown error'
    )
  }
})
